import { useEffect, useState } from "react";

export default function Background({
  children,
}: {
  children: React.ReactNode;
}) {
  const [hearts, setHearts] = useState<
    {
      id: number;
      left: number;
      animationDuration: number;
    }[]
  >([]);

  useEffect(() => {
    const createHeart = () => {
      const heart = {
        id: Math.random(),
        left: Math.random() * 100 - 5,
        animationDuration: 5 + Math.random() * 1,
      };

      setHearts((prev) => [...prev, heart]);

      setTimeout(() => {
        setHearts((prev) => prev.filter((h) => h.id !== heart.id));
      }, heart.animationDuration * 1000);
    };

    if (import.meta.env.PROD) {
      const intervalId = setInterval(createHeart, 500);

      // Start with initial heart instead of waiting 500ms
      createHeart();

      return () => clearInterval(intervalId);
    }
  }, []);

  return (
    <div className="relative h-dvh w-full overflow-hidden">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="absolute w-8 h-8 bg-contain bg-no-repeat animate-float"
          style={{
            left: `${heart.left}%`,
            animation: `float ${heart.animationDuration}s linear forwards`,
            backgroundImage: "url('/heart.png')",
          }}
        />
      ))}

      <div className="relative h-full">{children}</div>
    </div>
  );
}
